import Vue from 'vue'
import Router from 'vue-router'

const Login = () => import('@/pages/login')

const Main = () => import('@/pages/main')

var pages = ['数据统计', '识别记录', '识别记录详细', '入组筛选', '入组筛选详细', '筛选期流程','入组后流程','志愿者', '志愿者详细','流程历史','流程历史详情','筛选失败', '筛选失败详细', '流程记录', '流程记录记录', '流程记录详细', '试验资料库', '操作记录', '机构列表', '添加机构', '科室列表', '添加项目', '项目列表', '流程常用语管理', '角色管理', '用户管理', '修改密码', '成员管理', '项目详情', '项目详细', '人员管理', '人员列表', '人员研究者PI详细', '角色类型管理', '菜单管理', '运营平台管理', '设定项目流程', '添加监管层', '监管层列表', '监管层详细', '申办方列表', 'PI列表', '项目授权', '设定', '研究者列表', '设定提醒', '模板预览', 'CRO列表', 'SMO列表', '终端APP升级', '条码打印', '模板管理', '流程设计', '创建流程', '流程步骤', '审核详细', '我的信息', '待办工作', '审批日志', '审核', '项目审核详细', '机构审核详细', '申请项目','SMO账号列表']

var routerOptions = {
  routes: [{
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/main',
      name: 'main',
      component: Main,
      children: [{
        path: '/' + encodeURIComponent('入组筛选记录'),
        component: () => import('@/pages/入组筛选'),
        name: '入组筛选记录',
        meta: { keepAlive: false }
      }]
    },
    {
      path: '/organization',
      name: 'Organization',
      component: () => import('@/pages/新机构申请')
    },
    {
      path: '/item',
      name: 'Item',
      component: () => import('@/pages/新项目申请')
    },
    {
      path: '/appDownload',
      name: 'AppDownload',
      component: () => import('@/pages/APP下载')
    },
  ]
}

for (let page of pages) {
  if (page === '添加项目' || page === '添加机构') {
    routerOptions.routes[1].children.push({
      path: '/' + encodeURIComponent(page),
      component: () => import('@/pages/' + page),
      name: page,
      meta: { keepAlive: true }
    })
  } else {
    routerOptions.routes[1].children.push({
      path: '/' + encodeURIComponent(page),
      component: () => import('@/pages/' + page),
      name: page,
      meta: { keepAlive: false }
    })
  }
}

Vue.use(Router)

const router = new Router(routerOptions)
router.beforeEach((to, from, next) => {
  //console.log(to,from.name)
  if(!to.name){
    let name = to.path.replace("/","");
    next({name:name,path:'/'+encodeURIComponent(name)});
    return
  }
  next()
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js